import { defineMessages } from 'react-intl'

export default defineMessages({
    unavailable: {
        defaultMessage: 'No hay disponibilidad para estas fechas en este parking',
    },
    unavailableRates: {
        defaultMessage: 'No hay disponibilidad para estas fechas en este parking',
    },
    unavailableParkingFull: {
        defaultMessage: 'No hay disponibilidad para estas fechas en este parking',
    },
    unavailableParkingClosed: {
        defaultMessage: 'No hay disponibilidad para estas fechas en este parking',
    },
    unavailableBookingAdvanceTimeReached: {
        defaultMessage: 'Este parking no admite reservas con menos de {duration} de antelación',
    },
    unavailableBookingMaxStayTimeReached: {
        defaultMessage: 'El tiempo máximo de reserva en este parking es de {duration}',
    },
    unavailableBookingMinStayNotReached: {
        defaultMessage: 'El tiempo mínimo de reserva en este parking es de {duration}',
    },
    unknown: {
        defaultMessage: 'Error al obtener disponibilidad de reserva',
    },
})
